<template>
    <div v-if="stats">
        <div class="col-md-12">
            <issues-card :registration="registration" :simulation="simulation" :stats="stats" :sync="sync"
                @reload="$emit('reload')"
            ></issues-card>
        </div>
    </div>
</template>

<script>
    import IssuesCard from './summary/IssuesCard'

    export default {

        components: {
            IssuesCard
        },

        props: {

            registration: {
                type: Object,
                required: true
            },

            simulation: {
                type: Object,
                required: true
            },

            stats: {
                type: Object,
                required: true
            },

            sync: {
                type: Object,
                default: null
            },
        },
    }
</script>

